"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MortgageHouseDollarsIcon_1 = __importDefault(require("../../../../../../../Icons/MortgageButton/MortgageHouseDollarsIcon"));
var CalculatorIcon_1 = __importDefault(require("../../../../../../../Icons/CalculatorIcon"));
var MortgageButton_1 = __importDefault(require("../../../../../../../MortgageButton"));
var react_i18next_1 = require("react-i18next");
var ColorCodes_1 = require("../../../../../../../../constants/ColorCodes");
var style_module_scss_1 = __importDefault(require("../../../style.module.scss"));
var MortgageItemRow = function (_a) {
    var price = _a.price, region = _a.region, district = _a.district, address = _a.address, currency = _a.currency, handleSelectApartmentItem = _a.handleSelectApartmentItem;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: style_module_scss_1.default.bl_amenity_list },
        react_1.default.createElement("div", { className: "amenity-item" },
            react_1.default.createElement("div", { className: "push-left" },
                react_1.default.createElement("div", { className: style_module_scss_1.default.house_icon },
                    react_1.default.createElement(MortgageHouseDollarsIcon_1.default, null)),
                react_1.default.createElement("span", { className: "title" }, t('POST_PREVIEW.APARTMENTS_INFO_SECTION.MORTGAGE'))),
            react_1.default.createElement("div", { className: "amenity-info" },
                react_1.default.createElement("div", { className: style_module_scss_1.default.mortgage_section },
                    react_1.default.createElement("div", { onClick: handleSelectApartmentItem, className: style_module_scss_1.default.calculation },
                        react_1.default.createElement(CalculatorIcon_1.default, { color: ColorCodes_1.COLOR_CODES.GREY })),
                    react_1.default.createElement("div", { className: style_module_scss_1.default.mortgage_button },
                        react_1.default.createElement(MortgageButton_1.default, { price: [
                                {
                                    price: price,
                                    currency: currency,
                                },
                            ], region: region, district: district, address: address, hasIcon: false })))))));
};
exports.default = MortgageItemRow;
